//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets all roles.
 */
export function getRoles(config?: AxiosRequestConfig | undefined): Promise<Types.RoleDto[]> {
    let url_ = getBaseUrl() + "/api/roles";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRoles,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetRoles?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRoles(_response);
    });
}

function processGetRoles(response: AxiosResponse): Promise<Types.RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initRoleDto(item)
              );
            }
        return Promise.resolve<Types.RoleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RoleDto[]>(null as any);
}

/**
 * Creates a role.
 * @param newRole Request parameter
 */
export function createRole(newRole: Types.CreateRoleDto, config?: AxiosRequestConfig | undefined): Promise<Types.RoleDto> {
    let url_ = getBaseUrl() + "/api/roles";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateRoleDto(newRole);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateRole,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateRole?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateRole(_response);
    });
}

function processCreateRole(response: AxiosResponse): Promise<Types.RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRoleDto(resultData200);
        return Promise.resolve<Types.RoleDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initRoleDto(resultData201);
        return Promise.resolve<Types.RoleDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RoleDto>(null as any);
}

/**
 * Gets permissions.
 */
export function getPermissions(config?: AxiosRequestConfig | undefined): Promise<string[]> {
    let url_ = getBaseUrl() + "/api/roles/permissions";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPermissions,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetPermissions?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPermissions(_response);
    });
}

function processGetPermissions(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200;
        return Promise.resolve<string[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string[]>(null as any);
}

/**
 * Gets a role by id.
 * @param id The role id.
 */
export function getRole(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.RoleDto> {
    let url_ = getBaseUrl() + "/api/roles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRole,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetRole?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRole(_response);
    });
}

function processGetRole(response: AxiosResponse): Promise<Types.RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRoleDto(resultData200);
        return Promise.resolve<Types.RoleDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RoleDto>(null as any);
}

/**
 * Edits a role.
 * @param id The role id.
 * @param updatedRole Request parameter
 */
export function editRole(id: number, updatedRole: Types.UpdateRoleDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateRoleDto(updatedRole);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditRole,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditRole?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditRole(_response);
    });
}

function processEditRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes a role.
 * @param id The role id.
 */
export function removeRole(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/roles/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveRole,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveRole?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveRole(_response);
    });
}

function processRemoveRole(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetRoles: Partial<AxiosRequestConfig> | null;
export function getGetRolesRequestConfig() {
  return _requestConfigGetRoles;
}
export function setGetRolesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRoles = value;
}
export function patchGetRolesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRoles = patch(_requestConfigGetRoles ?? {});
}

let _requestConfigCreateRole: Partial<AxiosRequestConfig> | null;
export function getCreateRoleRequestConfig() {
  return _requestConfigCreateRole;
}
export function setCreateRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateRole = value;
}
export function patchCreateRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateRole = patch(_requestConfigCreateRole ?? {});
}

let _requestConfigGetPermissions: Partial<AxiosRequestConfig> | null;
export function getGetPermissionsRequestConfig() {
  return _requestConfigGetPermissions;
}
export function setGetPermissionsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPermissions = value;
}
export function patchGetPermissionsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPermissions = patch(_requestConfigGetPermissions ?? {});
}

let _requestConfigGetRole: Partial<AxiosRequestConfig> | null;
export function getGetRoleRequestConfig() {
  return _requestConfigGetRole;
}
export function setGetRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRole = value;
}
export function patchGetRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRole = patch(_requestConfigGetRole ?? {});
}

let _requestConfigEditRole: Partial<AxiosRequestConfig> | null;
export function getEditRoleRequestConfig() {
  return _requestConfigEditRole;
}
export function setEditRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditRole = value;
}
export function patchEditRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditRole = patch(_requestConfigEditRole ?? {});
}

let _requestConfigRemoveRole: Partial<AxiosRequestConfig> | null;
export function getRemoveRoleRequestConfig() {
  return _requestConfigRemoveRole;
}
export function setRemoveRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveRole = value;
}
export function patchRemoveRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveRole = patch(_requestConfigRemoveRole ?? {});
}